import AppService from "./app.service";

const SurveyService = () => {
    return Object.freeze({
        saveWellnessSurvey: async (wellnessSurvey) => {
            return await AppService.submit(wellnessSurvey, "surveys/wellness");
        },
        saveJobConfidenceSurvey: async (jobConfidenceSurvey) => {
            return await AppService.submit(jobConfidenceSurvey, "surveys/job-confidence");
        },
    });
};

export default SurveyService;